import React, { Component, ReactNode } from 'react';
import { DatePickerSelectType, FormicaTimePickerDate } from './TimePickerDomain';
import { OverlayPanel } from 'primereact/overlaypanel';
import Icon from '../../../icons/Icon';
import _ from 'lodash';
import DateFilterComponent from './DateFilterComponent';
import LanguageUtil from '../../../util/LanguageUtil';

class TimePickerContainer extends Component<Props, State> {
  public state = new State();
  private datePickerRef: OverlayPanel | null = null;

  public render(): ReactNode {
    const { startDate, endDate, roundVisible, positionTop } = this.props;
    return (
      <div
        className={'flex 2xl:min-w-[320px] min-w-[380px] w-full h-[35px] items-between justify-center border rounded'}
        data-testid={this.props['data-testid']}
      >
        <div
          onClick={(e) => this.showDatePicker(e, 'QUICK')}
          className={'text-primary border-r px-2 w-[30px] cursor-pointer h-full flex items-center justify-center '}
        >
          <Icon icon={'calendar'} className={'text-primary'} size={16} />
        </div>
        <div onClick={(e) => this.showDatePicker(e)} className={'flex gap-x-2 w-full items-center justify-center'} data-testid={'date_picker_edit_container'}>
          <div className={'text-primary cursor-pointer truncate inline-flex text-xs'}>{this.getTimePickerStartDateHeader()}</div>
          <div>
            <Icon icon={'arrow-right'} size={20} />
          </div>
          <div className={'text-primary cursor-pointer truncate inline-flex text-xs'}>{this.getTimePickerEndDateHeader()}</div>
        </div>
        <OverlayPanel
          ref={(el) => (this.datePickerRef = el)}
          dismissable={true}
          className={'flex flex-col'}
          style={{ transform: positionTop ? 'translateY(-110%) translateX(-20%)' : '' }}
        >
          <DateFilterComponent
            startDate={startDate}
            endDate={endDate}
            onChangeEndDate={this.setEndDate}
            selectType={this.state.selectType}
            onChangeStartDate={this.setStartDateWithCondition}
            onApply={this.onDateFilterApply}
            roundVisible={roundVisible}
          />
        </OverlayPanel>
      </div>
    );
  }

  private onDateFilterApply = () => {
    this.datePickerRef?.hide();
  };

  private setEndDate = (date: FormicaTimePickerDate) => {
    const { onChangeEndDate } = this.props;
    onChangeEndDate(date);
  };

  private setStartDateWithCondition = (date: FormicaTimePickerDate) => {
    const { onChangeStartDate } = this.props;
    onChangeStartDate(date);
  };
  // Hata çıkarsa kullanılacak
  // private getTimePickerStartDateHeader = (): string => {
  //   const {startDate} = this.props;
  //   return startDate.label as string || startDate.value as string || LanguageUtil.get({id: "common.label.startDate", defaultMessage: "Start Date"});
  // }

  // private getTimePickerEndDateHeader = (): string => {
  //   const {endDate} = this.props;
  //   return endDate.label as string || endDate.value as string || LanguageUtil.get({id: "common.label.endDate", defaultMessage: "End Date"});
  // }

  private getTimePickerStartDateHeader = (): string => {
    const { startDate } = this.props;
    return (
      startDate.label ||
      (startDate.value instanceof Date ? startDate.value.toLocaleString() : startDate.value) ||
      LanguageUtil.get({ id: 'common.label.startDate', defaultMessage: 'Start Date' })
    );
  };

  private getTimePickerEndDateHeader = (): string => {
    const { endDate } = this.props;
    return (
      endDate.label ||
      (endDate.value instanceof Date ? endDate.value.toLocaleString() : endDate.value) ||
      LanguageUtil.get({ id: 'common.label.endDate', defaultMessage: 'End Date' })
    );
  };

  private showDatePicker = (e: any, selectType?: DatePickerSelectType) => {
    this.datePickerRef?.toggle(e);
    if (selectType == undefined) {
      this.setState({ selectType: 'DEFAULT' });
      return;
    }
    this.setState({ selectType });
  };
}

class State {
  selectType: DatePickerSelectType = 'DEFAULT';
}

interface Props {
  startDate: FormicaTimePickerDate;
  endDate: FormicaTimePickerDate;
  onChangeStartDate: (date: FormicaTimePickerDate) => void;
  onChangeEndDate: (date: FormicaTimePickerDate) => void;
  roundVisible?: boolean;
  positionTop?: boolean;
  'data-testid'?: string;
}

export const saveDatesToLocalStorage = (startDate: FormicaTimePickerDate, endDate: FormicaTimePickerDate) => {
  if (Object.keys(startDate).length == 0 || Object.keys(endDate).length == 0) {
    return;
  }
  const item = localStorage.getItem('dates');
  if (item) {
    const dates: { startDate: FormicaTimePickerDate; endDate: FormicaTimePickerDate }[] = JSON.parse(item);
    const existingIndex = dates.findIndex((d) => _.isEqual(d.startDate, startDate) && _.isEqual(d.endDate, endDate));
    if (existingIndex != -1) {
      dates.splice(existingIndex, 1);
    }
    if (dates.length > 11) {
      dates.shift();
    }
    const _dates = [{ startDate, endDate }, ...dates];
    localStorage.setItem('dates', JSON.stringify(_dates));
  } else {
    localStorage.setItem('dates', JSON.stringify([{ startDate, endDate }]));
  }
};

export default TimePickerContainer;
